import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pla-suffix-number-plates',
  templateUrl: './suffix-number-plates.component.html',
  styleUrls: ['./suffix-number-plates.component.scss']
})
export class SuffixNumberPlatesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
